const formatMoney = (cents) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format((cents || 0) / 100);
};

const updateCartCount = (count) => {
  document.querySelectorAll('[data-cart-count]').forEach((node) => {
    node.textContent = count;
  });
};

const cartDrawer = (() => {
  const drawer = document.getElementById('mr-cart-drawer');
  const overlay = document.getElementById('mr-drawer-overlay');
  const closeButton = document.getElementById('mr-drawer-close');
  const itemsNode = document.getElementById('mrd-items');
  const summaryNode = document.getElementById('mrd-summary');
  const progressText = document.getElementById('mrd-progress-text');
  const progressFill = document.getElementById('mrd-progress-fill');
  const progressKnob = document.getElementById('mrd-progress-knob');
  const bannerText = document.getElementById('mrd-banner-text');
  const bundleNode = document.getElementById('mrd-bundle');
  const upsellNode = document.getElementById('mrd-upsell');
  const upsellListNode = document.getElementById('mrd-upsell-list');
  const timerNode = document.getElementById('mrd-timer');
  const productsDataNode = document.getElementById('mrd-products-data');
  const productsData = productsDataNode ? JSON.parse(productsDataNode.textContent || '[]') : [];
  const freeShippingThreshold = 10000;
  let timerInterval;

  if (!drawer || !overlay || !itemsNode || !summaryNode) {
    return {
      refresh: async () => null,
      open: () => {},
      close: () => {}
    };
  }

  const startTimer = () => {
    window.clearInterval(timerInterval);
    let remaining = 10 * 60;
    const tick = () => {
      const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      if (timerNode) timerNode.textContent = `${minutes}:${seconds}`;
      if (remaining > 0) remaining -= 1;
    };
    tick();
    timerInterval = window.setInterval(tick, 1000);
  };

  const open = () => {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('mr-cart-open');
    startTimer();
  };

  const close = () => {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('mr-cart-open');
  };

  const updateProgress = (cart) => {
    const total = cart.total_price || 0;
    const remaining = Math.max(freeShippingThreshold - total, 0);
    const progress = Math.min((total / freeShippingThreshold) * 100, 100);

    if (progressText) {
      progressText.innerHTML = remaining > 0
        ? `Noch <strong>${formatMoney(remaining)}</strong> bis zum kostenlosen Versand`
        : 'Du hast kostenlosen Versand erreicht';
    }

    if (bannerText) {
      bannerText.textContent = remaining > 0 ? 'Kostenloser Versand ab 100 EUR' : 'Kostenloser Versand aktiv';
    }

    if (progressFill) progressFill.style.width = `${progress}%`;
    if (progressKnob) progressKnob.style.left = `${progress}%`;
  };

  const renderBundleHint = (cart) => {
    if (!bundleNode) return;
    const tshirtCount = (cart.items || []).reduce((count, item) => {
      const text = `${item.product_title || ''} ${item.product_type || ''} ${item.variant_title || ''}`.toLowerCase();
      return text.includes('shirt') ? count + item.quantity : count;
    }, 0);
    bundleNode.style.display = tshirtCount === 1 ? 'flex' : 'none';
  };

  const renderUpsells = (cart) => {
    if (!upsellNode || !upsellListNode) return;
    const idsInCart = new Set((cart.items || []).map((item) => item.product_id));
    const picks = productsData.filter((product) => !idsInCart.has(product.id)).slice(0, 2);

    if (!picks.length) {
      upsellNode.style.display = 'none';
      upsellListNode.innerHTML = '';
      return;
    }

    upsellListNode.innerHTML = picks.map((product) => {
      const availableVariant = (product.variants || []).find((variant) => variant.available);
      if (!availableVariant) return '';
      return `
        <div class="mrd-upsell__card${product.isTshirt ? ' mrd-upsell__card--bundle' : ''}">
          ${product.isTshirt ? '<span class="mrd-upsell__badge">25% Bundle</span>' : ''}
          <div class="mrd-upsell__img"><img src="${product.image || ''}" alt="${product.title}"></div>
          <div>
            <a class="mrd-upsell__name" href="/products/${product.handle}">${product.title}</a>
            <p class="mrd-upsell__price">${formatMoney(product.price)}</p>
          </div>
          <button type="button" class="mrd-upsell__add" data-upsell-add="${availableVariant.id}" aria-label="${product.title} hinzufügen">+</button>
        </div>
      `;
    }).join('');
    upsellNode.style.display = 'block';
  };

  const renderItems = (cart) => {
    if (!cart.items || !cart.items.length) {
      itemsNode.innerHTML = `
        <div class="mrd-empty">
          <p class="mrd-empty__title">Dein Warenkorb ist leer</p>
          <a class="mrd-continue" href="/collections/all">Weiter einkaufen</a>
        </div>
      `;
      summaryNode.innerHTML = '';
      if (bundleNode) bundleNode.style.display = 'none';
      if (upsellNode) upsellNode.style.display = 'none';
      return;
    }

    itemsNode.innerHTML = cart.items.map((item) => `
      <article class="mrd-item" data-cart-key="${item.key}">
        <a class="mrd-item__image" href="${item.url}"><img src="${item.image || ''}" alt="${item.product_title}"></a>
        <div class="mrd-item__content">
          <a class="mrd-item__title" href="${item.url}">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="mrd-item__variant">${item.variant_title}</p>` : ''}
          <div class="mrd-item__footer">
            <div class="mrd-item__qty">
              <button type="button" data-drawer-qty="minus" data-key="${item.key}" aria-label="Menge reduzieren">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-drawer-qty="plus" data-key="${item.key}" aria-label="Menge erhöhen">+</button>
            </div>
            <strong class="mrd-item__price">${formatMoney(item.final_line_price)}</strong>
          </div>
        </div>
      </article>
    `).join('');

    summaryNode.innerHTML = `
      <div class="mrd-summary__row"><span>Zwischensumme</span><strong>${formatMoney(cart.total_price)}</strong></div>
      <div class="mrd-summary__row"><span>Versand</span><span>${cart.total_price >= freeShippingThreshold ? 'Kostenlos' : 'Im Checkout berechnet'}</span></div>
    `;

    renderBundleHint(cart);
    renderUpsells(cart);
  };

  const render = (cart) => {
    updateCartCount(cart.item_count || 0);
    updateProgress(cart);
    renderItems(cart);
  };

  const refresh = async (shouldOpen = false) => {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
    render(cart);
    if (shouldOpen) open();
    return cart;
  };

  const changeQuantity = async (key, quantity) => {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity })
    });
    await refresh();
  };

  closeButton?.addEventListener('click', close);
  overlay?.addEventListener('click', close);

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-cart-trigger]');
    if (trigger) {
      event.preventDefault();
      await refresh(true);
      return;
    }

    const link = event.target.closest('a[href]');
    if (link && !link.closest('#mr-cart-drawer')) {
      try {
        const url = new URL(link.href, window.location.origin);
        if (url.pathname.endsWith('/cart')) {
          event.preventDefault();
          await refresh(true);
          return;
        }
      } catch (error) {}
    }

    const qtyButton = event.target.closest('[data-drawer-qty]');
    if (qtyButton) {
      const key = qtyButton.getAttribute('data-key');
      const itemNode = qtyButton.closest('[data-cart-key]');
      const currentQty = Number(itemNode?.querySelector('.mrd-item__qty span')?.textContent || 0);
      const nextQty = qtyButton.getAttribute('data-drawer-qty') === 'plus' ? currentQty + 1 : currentQty - 1;
      if (nextQty >= 0) await changeQuantity(key, nextQty);
      return;
    }

    const upsellButton = event.target.closest('[data-upsell-add]');
    if (upsellButton) {
      upsellButton.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: Number(upsellButton.getAttribute('data-upsell-add')), quantity: 1 }] })
        });
        await refresh();
      } finally {
        upsellButton.disabled = false;
      }
      return;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  refresh();
  return { refresh, open, close };
})();

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const originalText = button ? button.textContent : '';

  try {
    if (button) {
      button.disabled = true;
      button.textContent = 'ADDING...';
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) throw new Error('Cart request failed');

    const cart = await cartDrawer.refresh(true);
    updateCartCount(cart?.item_count || 0);

    if (button) button.textContent = 'ADDED';
    window.setTimeout(() => {
      if (button) button.textContent = originalText;
    }, 1300);
  } catch (error) {
    if (button) button.textContent = 'TRY AGAIN';
  } finally {
    window.setTimeout(() => {
      if (button) button.disabled = false;
    }, 1300);
  }
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-localization-select]');
  if (!selector) return;
  selector.form.submit();
});

document.querySelectorAll('[data-locale-dropdown]').forEach((dropdown) => {
  dropdown.addEventListener('toggle', () => {
    if (!dropdown.open) return;
    document.querySelectorAll('[data-locale-dropdown]').forEach((otherDropdown) => {
      if (otherDropdown !== dropdown) otherDropdown.open = false;
    });
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-locale-dropdown]').forEach((dropdown) => {
    if (!dropdown.contains(event.target)) dropdown.open = false;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-locale-dropdown]').forEach((dropdown) => {
    dropdown.open = false;
  });
});

const header = document.querySelector('.mr-header');
let lastScrollY = window.scrollY;
let ticking = false;

const updateHeaderMotion = () => {
  if (!header) return;
  const currentScrollY = window.scrollY;
  header.classList.toggle('is-scrolled', currentScrollY > 12);
  header.classList.toggle('is-hidden', currentScrollY > lastScrollY && currentScrollY > 180);
  lastScrollY = Math.max(currentScrollY, 0);
  ticking = false;
};

window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(updateHeaderMotion);
    ticking = true;
  }
}, { passive: true });

const revealTargets = document.querySelectorAll([
  '.mr-section',
  '.mr-editorial',
  '.mr-reviews',
  '.mr-community',
  '.mr-card',
  '.mr-review',
  '.mr-product-main',
  '.mr-collection-main',
  '.mr-product-gallery .mr-card__media',
  '.mr-product-panel'
].join(','));

revealTargets.forEach((target) => target.classList.add('mr-reveal'));

if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  revealTargets.forEach((target) => revealObserver.observe(target));
} else {
  revealTargets.forEach((target) => target.classList.add('is-visible'));
}

document.querySelectorAll('[data-community-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-carousel-track]');
  const prev = carousel.querySelector('[data-carousel-prev]');
  const next = carousel.querySelector('[data-carousel-next]');
  if (!track || !prev || !next) return;
  let autoplay;
  let paused = false;

  const scrollBySlide = (direction) => {
    const firstSlide = track.children[0];
    const distance = firstSlide ? firstSlide.getBoundingClientRect().width + 6 : 260;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - distance;
    if (direction > 0 && atEnd) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }
    track.scrollBy({ left: direction * distance * 1.5, behavior: 'smooth' });
  };

  prev.addEventListener('click', () => scrollBySlide(-1));
  next.addEventListener('click', () => scrollBySlide(1));
  carousel.addEventListener('mouseenter', () => {
    paused = true;
  });
  carousel.addEventListener('mouseleave', () => {
    paused = false;
  });
  carousel.addEventListener('focusin', () => {
    paused = true;
  });
  carousel.addEventListener('focusout', () => {
    paused = false;
  });

  autoplay = window.setInterval(() => {
    if (!paused && document.visibilityState === 'visible') scrollBySlide(1);
  }, 4200);

  carousel.addEventListener('remove', () => window.clearInterval(autoplay));
});

document.querySelectorAll('[data-review-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-review-track]');
  if (!track) return;

  let direction = 1;
  let paused = false;
  let autoplay;

  const step = () => {
    if (paused || document.visibilityState !== 'visible') return;

    const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
    if (maxScroll <= 0) return;

    const nextLeft = track.scrollLeft + direction * 320;

    if (nextLeft >= maxScroll) {
      direction = -1;
      track.scrollTo({ left: maxScroll, behavior: 'smooth' });
      return;
    }

    if (nextLeft <= 0) {
      direction = 1;
      track.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    track.scrollTo({ left: nextLeft, behavior: 'smooth' });
  };

  const start = () => {
    window.clearInterval(autoplay);
    autoplay = window.setInterval(step, 2800);
  };

  carousel.addEventListener('mouseenter', () => {
    paused = true;
  });

  carousel.addEventListener('mouseleave', () => {
    paused = false;
  });

  carousel.addEventListener('focusin', () => {
    paused = true;
  });

  carousel.addEventListener('focusout', () => {
    paused = false;
  });

  start();
  carousel.addEventListener('remove', () => window.clearInterval(autoplay));
});
